import {RouteLocationNormalized} from "vue-router";
import {AppRouteMeta} from "@/core/app/types";
import merge from "lodash-es/merge";

export function collectMeta(to: RouteLocationNormalized): AppRouteMeta {
    return merge({}, ...to.matched.map(record => record.meta))
}
